import createIcon from '../../createIcon';

/**
 * @component @name EditAttributes
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNjMgN0g2LjM3QzMuOTYgNyAyIDkuMjQgMiAxMkMyIDE0Ljc2IDMuOTYgMTcgNi4zNyAxN0gxNy42M0MyMC4wNCAxNyAyMiAxNC43NiAyMiAxMkMyMiA5LjI0IDIwLjA0IDcgMTcuNjMgN1pNNy4yNCAxNC40Nkw0LjY3IDExLjg5TDUuMzcgMTEuMTlMNy4yNCAxMy4wNkwxMC43NiA5LjU0TDExLjQ2IDEwLjI0TDcuMjQgMTQuNDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EditAttributes = createIcon('EditAttributes', [
  [
    'path',
    {
      d: 'M17.63 7H6.37C3.96 7 2 9.24 2 12C2 14.76 3.96 17 6.37 17H17.63C20.04 17 22 14.76 22 12C22 9.24 20.04 7 17.63 7ZM7.24 14.46L4.67 11.89L5.37 11.19L7.24 13.06L10.76 9.54L11.46 10.24L7.24 14.46Z',
      key: 'huus2g',
    },
  ],
]);

export default EditAttributes;
